import { Application, extend } from '@pixi/react';
import { Container, Sprite } from 'pixi.js';
import type { ReactNode, RefObject } from 'react';

extend({ Container, Sprite });

interface SceneCanvasProps {
  /** Element whose size the canvas follows. */
  resizeTo: RefObject<HTMLElement | null>;
  children?: ReactNode;
}

/**
 * Transparent PixiJS layer for lighting, particles and other effects. It never receives input;
 * React renders all interactive UI above it.
 */
export function SceneCanvas({ resizeTo, children }: SceneCanvasProps) {
  return (
    <Application
      resizeTo={resizeTo}
      backgroundAlpha={0}
      antialias
      autoDensity
      resolution={Math.min(window.devicePixelRatio, 2)}
      powerPreference="low-power"
    >
      {children}
    </Application>
  );
}
